import { cn } from '@/utils/cn'
import { focusRing } from '@/components/ui/buttonStyles'
import { ADMIN_SECTION_GROUPS } from './adminSections'
import { AdminSectionPicker } from './AdminSectionPicker'
import type { AdminTab } from '@/types/admin'

interface AdminSidebarProps {
  active: AdminTab
  onSelect: (key: AdminTab) => void
}

/**
 * The panel's navigation. A vertical, grouped sidebar from `lg` up, and below that
 * `AdminSectionPicker` — nine sections in a sideways strip hid most of them off-screen
 * behind a scroll nobody expects.
 */
export function AdminSidebar({ active, onSelect }: AdminSidebarProps) {
  return (
    <>
      <AdminSectionPicker active={active} onSelect={onSelect} />

      <nav aria-label="Admin sections" className="hidden lg:flex lg:flex-col lg:gap-6">
        {ADMIN_SECTION_GROUPS.map((group) => (
          <div key={group.label} className="flex flex-col gap-0.5">
            <p className="px-3 pb-1.5 font-mono text-[0.65rem] uppercase tracking-widest text-muted">
              {group.label}
            </p>
            {group.sections.map((section) => {
              const selected = section.key === active
              return (
                <button
                  key={section.key}
                  type="button"
                  onClick={() => onSelect(section.key)}
                  aria-current={selected ? 'page' : undefined}
                  className={cn(
                    'min-h-11 rounded-md px-3 py-2 text-left text-sm transition-colors duration-200',
                    selected
                      ? 'bg-surface-bg font-normal text-heading'
                      : 'font-light text-muted hover:bg-surface-bg/60 hover:text-body',
                    focusRing,
                  )}
                >
                  {section.label}
                </button>
              )
            })}
          </div>
        ))}
      </nav>
    </>
  )
}
